import {AccountFieldsFragment, AccountStatus} from 'api/generated';

export const hasStatusReason = (status?: AccountStatus | null) => {
  if (!status) return false;
  return [AccountStatus.REJECTED, AccountStatus.SUSPENDED, AccountStatus.NOT_CONFIGURED].includes(
    status
  );
};

export const checkFromAndorra = (account: AccountFieldsFragment | null | undefined) => {
  return account?.business?.country === 'AD';
};

export const checkFromComercia = (account: AccountFieldsFragment | null | undefined) => {
  return account?.promoCode === 'comercia';
};

export const checkSimplifiedAccount = (account: AccountFieldsFragment | null | undefined) => {
  return checkFromAndorra(account) || checkFromComercia(account);
};
